import * as types from '~/store/contact/contactType';

const initialState = {
  loading: false,
  data: 0,
  error: 0,
  messageNotification: '',
  contactForm: {
    name: { value: '' },
    email: { value: '' },
    company: { value: '' },
    mobile: { value: '' },
    type: { value: 0 },
    content: { value: '' },
  },
};

export default function locale(state = initialState, action = {}) {
  const mergeState = {
    ...state,
    info: {
      ...state.info,
      ...action.payload,
    },
  };
  switch (action.type) {
    case types.CONTACT_FORM_SAVE_FIELD: {
      return mergeState;
    }
    case types.POST_CONTACT_SUCCESS: {
      return {
        ...state,
        data: action.data.id,
        loading: false,
        messageNotification: 'success',
      };
    }
    case types.POST_CONTACT_FAIL: {
      return {
        ...state,
        // error: action.data.error_code,
        error: action.error.message,
        loading: false,
        messageNotification: 'error',
      };
    }
    case types.CONTACT_FORM_CHANGE_TYPE: {
      return {
        ...mergeState,
        info: {
          ...mergeState.info,
        },
      };
    }
    case types.RESET_CONTACT_FORM_FIELD: {
      return {
        ...initialState,
      };
    }
    default: {
      return { ...state };
    }
  }
}
